"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerArbitraryProps = registerArbitraryProps;
exports.getArbitraryProps = getArbitraryProps;
exports.registerUser = registerUser;
exports.getUserId = getUserId;

var _getPreferredUserId = _interopRequireDefault(require("../lib/getPreferredUserId"));

var _StoredLabsId = require("./StoredLabsId");

var _userId = (0, _StoredLabsId.getStoredLabsId)();

var _arbitraryProps = {};

function registerArbitraryProps(key, value) {
  _arbitraryProps[key] = value;
}

function getArbitraryProps() {
  return _arbitraryProps;
}

function registerUser(userIdentifier) {
  var preferredId = (0, _getPreferredUserId.default)(userIdentifier);
  (0, _StoredLabsId.setStoredLabsId)(preferredId);
  _userId = preferredId;
}

function getUserId() {
  if (!_userId) {
    return (0, _StoredLabsId.getStoredLabsId)() || null;
  }

  if (typeof _userId === 'function') {
    return _userId(_arbitraryProps);
  }

  return _userId;
}